/**
 * utils/mediaThumb.js — ЖАГСААЛТАД ЗОРИУЛСАН ЖИЖИГ ЗУРАГ (НЭГ ЭХ СУРВАЛЖ).
 *
 * ЯАГААД (2026-10-05, хэмжсэн онош):
 *   `/morningxab/register` «маш удаан нээгддэг» гэсэн гомдол. Backend нь
 *   хурдан байв (3 хүсэлт нийт 332 мс). Шалтгаан нь жагсаалт зургийг
 *   150×110-аар ХАРУУЛЖ, MinIO-гоос БҮТЭН файлыг ТАТАЖ байсан:
 *   эхний 20 мөр = 34 зураг = **46.6 MB**. Ижил хэв маяг аппын ~20
 *   газар бий тул дүрмийг ЭНД нэг удаа бичиж, тэднийг үүн рүү чиглүүлнэ.
 *
 * КОНВЕНЦ (backend `Utils/image_thumb.py`-тай ЯГ ИЖИЛ байх ёстой):
 *     эх    : <host>/<bucket>/morning/photos/<uuid>.jpg
 *     жижиг : <host>/<bucket>/morning/photos/thumb/<uuid>.jpg
 *   Файлын нэрний ӨМНӨ `thumb/` хавтас оруулна.
 *
 * ⚠ ЖИЖИГ ЗУРАГ БАЙХГҮЙ БАЙЖ БОЛНО. Хаягийг КОНВЕНЦООР гаргадаг тул
 *   файл байгаа гэсэн баталгаа БИШ: хуучин файлд үүсээгүй, эсвэл
 *   серверт Pillow байхгүй байж болно. Тиймээс хэрэглэх газар бүхэн
 *   ЗААВАЛ `onError` дээр эх зураг руу унах ёстой. `ThumbImg` нь
 *   түүнийг өөртөө агуулсан — шинэ код ҮҮНИЙГ хэрэглэ, гараар
 *   `<img src={thumbSrc(...)}>` бичихгүй.
 */
import React from "react";

/** Зураг гэж таних өргөтгөлүүд — видео/PDF-д жижиг зураг байхгүй */
const IMAGE_RE = /\.(jpe?g|png|webp|bmp|gif)(\?.*)?$/i;
const THUMB_DIR = "thumb";

export const isImageUrl = (url) => IMAGE_RE.test(String(url || ""));

/**
 * Эх зургийн хаягаас жижиг зургийн хаяг. Зураг биш, эсвэл аль хэдийн
 * `thumb/` дотор бол `null` (давхар `thumb/thumb/` болохоос сэргийлнэ).
 */
export function thumbSrc(url) {
  const s = String(url || "");
  if (!s || !isImageUrl(s)) return null;
  const i = s.lastIndexOf("/");
  if (i <= 0) return null;
  const head = s.slice(0, i);
  const name = s.slice(i + 1);
  if (!name || head.endsWith("/" + THUMB_DIR)) return null;
  return `${head}/${THUMB_DIR}/${name}`;
}

/**
 * Жижиг зураг + `loading="lazy"` + эх зураг руу унах хамгаалалт.
 *
 * `full` — эх зургийн хаяг (заавал). Бусад prop нь `<img>`-д дамжина.
 * `thumb` — сервер нь `thumb_url` буцаасан бол тэрийг дамжуулж болно;
 *   эс бөгөөс конвенцоор гаргана.
 *
 * ⚠ `data-full` ба `__fellBack` — унасны ДАРАА дахин унахаас сэргийлнэ.
 *   Эх зураг ч эвдэрхий бол `onError` хязгааргүй давтагдана.
 */
export function ThumbImg({ full, thumb, alt = "", style, ...rest }) {
  const first = thumb || thumbSrc(full) || full;
  return (
    <img
      src={first}
      data-full={full || ""}
      loading="lazy"
      decoding="async"
      alt={alt}
      onError={(e) => {
        const el = e.currentTarget;
        const f = el.getAttribute("data-full");
        if (f && !el.__fellBack && el.src !== f) {
          el.__fellBack = true;
          el.src = f;
        }
      }}
      /* Татагдах хүртэл цайвар дэвсгэр — эс бөгөөс мөр «цэлийнэ» */
      style={{ background: "#F0F0F0", ...(style || {}) }}
      {...rest}
    />
  );
}

export default ThumbImg;
